import React from 'react'
import HeaderBackgroundImage from '../../assets/imgs/profile-screen-images/header-image.png'
import '../../styles/ClientHeader.scss'

const ClientHeader = () => {
  return (
    <div
      style={{
        height: '100vh',
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${HeaderBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100vw',
        borderRadius: '0',
      }}
    >
      <div className="hero-text-wrapper">
        <div className="header-hero-text">
          <p className="fw-bold text-black">
            Get Services When & <br /> Where You Want It!
          </p>
          <p className="text-black">
            BodeWrk connects potential clients with freelance <br /> stylist
            that travels to the clients' locations.
          </p>
        </div>
      </div>
    </div>
  )
}

export default ClientHeader
